import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    userToken: null,
    userRole: null,
    userInfo: null,
  },
  reducers: {
    setUser: (state, action) => {
      state.userToken = action.payload?.access_token;
      state.userRole = action.payload?.user_role;
      state.userInfo = {
        last_name: action.payload?.last_name,
        first_name: action.payload?.first_name,
        user_id: action.payload?.user_id,
      };
    },
    clearUser: (state) => {
      state.userToken = null;
      state.userRole = null;
      state.userInfo = null;
    },
  },
});

export const { setUser, clearUser } = userSlice.actions;

export default userSlice.reducer;
